import { Link } from "react-router-dom";
import { Trophy, Medal, Star, CircleCheckBig } from "lucide-react";
import Avatar from "../common/Avatar";
import RankBadge from "../social/RankBadge";
import RankProgressBar from "./RankProgressBar";

const POSITION_CONFIG = [
  {
    icon: Trophy,
    iconColor: "text-amber",
    border: "border-2 border-terracotta",
    numClass: "text-2xl text-terracotta",
    avatarSize: "lg",
  },
  {
    icon: Medal,
    iconColor: "text-walnut-light",
    border: "border border-stone",
    numClass: "text-xl text-walnut-light",
    avatarSize: "md",
  },
  {
    icon: Medal,
    iconColor: "text-terracotta",
    border: "border border-stone",
    numClass: "text-xl text-walnut-light",
    avatarSize: "md",
  },
];

export default function TopThreeHero({ entries, currentUserId }) {
  if (!entries || entries.length === 0) return null;

  return (
    <div className="flex flex-col md:flex-row gap-4 mb-8">
      {entries.map((entry, i) => {
        const config = POSITION_CONFIG[i];
        const Icon = config.icon;
        const isCurrentUser = entry.user.id === currentUserId;
        const isFirst = i === 0;

        return (
          <Link
            key={entry.user.id}
            to={`/users/${entry.user.id}`}
            className={`flex-1 bg-cream rounded-lg shadow-card hover:shadow-card-hover transition-shadow text-center ${config.border} ${
              isFirst ? "p-6" : "p-4"
            } ${isCurrentUser ? "ring-2 ring-terracotta/40 bg-terracotta/5" : ""}`}
            style={{
              animation: "leaderboard-enter 0.5s ease-out forwards",
              animationDelay: `${400 + i * 150}ms`,
              opacity: 0,
            }}
          >
            <div className="flex justify-center mb-2">
              <Icon size={isFirst ? 28 : 22} className={config.iconColor} />
            </div>
            <div className="flex justify-center mb-2">
              <Avatar user={entry.user} size={isFirst ? "lg" : "md"} />
            </div>
            <div className="font-display font-bold mb-1">
              <span className={config.numClass}>{entry.position}</span>
            </div>
            <div className="flex items-center justify-center gap-1.5 mb-1">
              <span className={`font-medium text-walnut truncate ${isFirst ? "text-base" : "text-sm"}`}>
                {entry.user.display_name}
              </span>
              {entry.user.is_verified && (
                <CircleCheckBig size={14} className="text-terracotta flex-shrink-0" />
              )}
            </div>
            <div className="flex justify-center mb-2">
              <RankBadge rank={entry.user.rank} />
            </div>
            <div className="flex items-center justify-center gap-3 text-xs text-walnut-light">
              <span className="font-semibold text-amber">{entry.user.community_points} CP</span>
              {entry.user.rating_avg != null && (
                <span className="inline-flex items-center gap-0.5">
                  <Star size={11} className="fill-amber text-amber" />
                  {entry.user.rating_avg.toFixed(1)}
                  ({entry.user.rating_count})
                </span>
              )}
            </div>
            <RankProgressBar points={entry.user.community_points} />
            {isCurrentUser && (
              <span className="inline-block mt-2 text-[10px] font-semibold text-terracotta uppercase tracking-wider">
                You
              </span>
            )}
          </Link>
        );
      })}
    </div>
  );
}
